import React, { ReactNode } from 'react';

export type ErpProps = {
  children?: ReactNode;
};

export const Erp = ({ children }: ErpProps) => {
  return <>{children}</>;
};

export default Erp;
